module.exports = __webpack_public_path__ + "res/25-img_play_bg.e3857db4d93cf7709fbeeaf30cfa6172.png";